export default "__VITE_ASSET__BUGzHSJe__";